import React, { useMemo } from "react"

const urlRegex = /((?:https?:\/\/)(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;

const makeUrlStingBreakable = (url: string) => {
  const parts = url.split('/')
  return parts.map((part, index) => {
    return <span key={index}><span>{`${part}${index === parts.length -1 ? '' : '/'}`}</span><span style={{width: 0, display: 'inline-block'}}>{' '}</span></span>
  })
}

const splitIntoFragments = (text: string, targetBlank?: boolean) => {
  return text.split(urlRegex).map((word, index) => {
    const urlMatch = word.match(urlRegex);
    if (urlMatch) {
      const url = urlMatch[0];
      return (
        <a key={index} target={targetBlank && '_blank' || undefined} href={url.startsWith("http") ? url : `http://${url}`}>
          {makeUrlStingBreakable(url)}
        </a>
      );
    }
    return <span key={index}>{word}</span>;
  });  
}

const useAutoLinkedText = (text: string, targetBlank?: boolean) => {
  return useMemo(() => splitIntoFragments(text, targetBlank), [text, targetBlank])
}

export default useAutoLinkedText
